import localization from "../../../config/localization";
import { Modal } from "./Modal";

interface TransactionUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  dateTime: string;
  message: string;
}

export function TransactionUpdateModal({
  isOpen,
  onClose,
  dateTime,
  message,
}: TransactionUpdateModalProps) {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      imgSrc="/icons/ic-warning.svg"
      imgBlurColor="bg-[#FF4D4F]/30"
      onClose={onClose}
    >
      <h2 className="text-[22px] font-semibold text-[#1E1E1E]">
        {localization.transaction_update_lbl}
      </h2>

      <div className="mt-4 rounded-xl bg-[#1F2343] p-5 text-left text-white">
        <div className="text-right text-xs text-gray-300 mb-3">
          {dateTime}
        </div>

        <p className="text-sm leading-6 text-gray-100">
          {message}
        </p>
      </div>
    </Modal>
  );
}
